import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import memoize from 'memoize-one';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import GlobalTheme from '@atlaskit/theme/components';
import CheckboxIcon from './CheckboxIcon';
import { CheckboxWrapper, HiddenCheckbox, LabelOverrides, LabelTextOverrides, RequiredIndicator } from './elements';
import Theme, { componentTokens } from './theme';
import { createExtender } from './utils';
import { name as packageName, version as packageVersion } from './version.json';
var defaults = {
  Label: LabelOverrides,
  LabelText: LabelTextOverrides,
  HiddenCheckbox: {
    attributesFn: function attributesFn() {
      return {};
    }
  }
};

var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isActive: false,
      isFocused: false,
      isHovered: false,
      isMouseDown: false,
      isChecked: _this.props.isChecked !== undefined ? _this.props.isChecked : _this.props.defaultChecked
    });

    _defineProperty(_assertThisInitialized(_this), "checkbox", undefined);

    _defineProperty(_assertThisInitialized(_this), "actionKeys", [' ']);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      if (_this.props.isDisabled) {
        return null;
      }

      event.persist();

      if (event.target.checked !== undefined) {
        _this.setState({
          isChecked: event.target.checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      if (_this.checkbox && _this.checkbox.blur) {
        _this.checkbox.blur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      if (_this.checkbox && _this.checkbox.focus) {
        _this.checkbox.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      return _this.setState({
        // onBlur is called after onMouseDown if the checkbox was focused, however
        // in this case on blur is called immediately after, and we need to check
        // whether the mouse is down.
        isActive: _this.state.isMouseDown && _this.state.isActive,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      return _this.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      return _this.setState({
        isActive: false,
        isHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      return _this.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function () {
      return _this.setState({
        isActive: false,
        isMouseDown: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function () {
      return _this.setState({
        isActive: true,
        isMouseDown: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key in _this.actionKeys) {
        _this.setState({
          isActive: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
      if (event.key in _this.actionKeys) {
        _this.setState({
          isActive: false
        });
      }
    });

    _this.createExtender = memoize(createExtender);
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isIndeterminate = this.props.isIndeterminate; // there is no HTML attribute for indeterminate, and thus no prop equivalent.
      // it must be set via the ref.

      if (this.checkbox) {
        this.checkbox.indeterminate = !!isIndeterminate;

        if (this.props.inputRef) {
          this.props.inputRef(this.checkbox);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isIndeterminate = this.props.isIndeterminate;

      if (prevProps.isIndeterminate !== isIndeterminate && this.checkbox) {
        this.checkbox.indeterminate = !!isIndeterminate;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isDisabled = _this$props.isDisabled,
          isInvalid = _this$props.isInvalid,
          isIndeterminate = _this$props.isIndeterminate,
          label = _this$props.label,
          name = _this$props.name,
          overrides = _this$props.overrides,
          value = _this$props.value,
          isRequired = _this$props.isRequired,
          propsIsChecked = _this$props.isChecked,
          theme = _this$props.theme,
          testId = _this$props.testId;
      var isChecked = this.props.isChecked === undefined ? this.state.isChecked : propsIsChecked;
      var _this$state = this.state,
          isFocused = _this$state.isFocused,
          isActive = _this$state.isActive,
          isHovered = _this$state.isHovered;
      var getOverrides = createExtender(defaults, overrides);

      var _getOverrides = getOverrides('Label'),
          Label = _getOverrides.component,
          labelOverrides = _objectWithoutProperties(_getOverrides, ["component"]);

      var _getOverrides2 = getOverrides('LabelText'),
          LabelText = _getOverrides2.component,
          labelTextOverrides = _objectWithoutProperties(_getOverrides2, ["component"]);

      var _getOverrides3 = getOverrides('HiddenCheckbox'),
          hiddenCheckboxAttributesFn = _getOverrides3.attributesFn;

      return /*#__PURE__*/React.createElement(Theme.Provider, {
        value: theme
      }, /*#__PURE__*/React.createElement(GlobalTheme.Consumer, null, function (_ref) {
        var mode = _ref.mode;
        return /*#__PURE__*/React.createElement(Theme.Consumer, {
          mode: mode,
          tokens: componentTokens
        }, function (tokens) {
          return /*#__PURE__*/React.createElement(Label, _extends({}, labelOverrides, {
            isDisabled: isDisabled,
            onMouseDown: _this2.onMouseDown,
            onMouseEnter: _this2.onMouseEnter,
            onMouseLeave: _this2.onMouseLeave,
            onMouseUp: _this2.onMouseUp,
            tokens: tokens,
            testId: testId && "".concat(testId, "--checkbox-label")
          }), /*#__PURE__*/React.createElement(CheckboxWrapper, null, /*#__PURE__*/React.createElement(HiddenCheckbox, {
            disabled: isDisabled,
            checked: isChecked,
            onChange: _this2.onChange,
            onBlur: _this2.onBlur,
            onFocus: _this2.onFocus,
            onKeyUp: _this2.onKeyUp,
            onKeyDown: _this2.onKeyDown,
            value: value,
            name: name,
            ref: function ref(r) {
              return _this2.checkbox = r;
            },
            required: isRequired,
            attributesFn: hiddenCheckboxAttributesFn,
            testId: testId && "".concat(testId, "--hidden-checkbox")
          }), /*#__PURE__*/React.createElement(CheckboxIcon, {
            theme: theme,
            overrides: {
              IconWrapper: overrides && overrides.IconWrapper,
              Icon: overrides && overrides.Icon,
              IconIndeterminate: overrides && overrides.IconIndeterminate
            },
            isChecked: isChecked,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isActive: isActive,
            isHovered: isHovered,
            isInvalid: isInvalid,
            isIndeterminate: isIndeterminate,
            primaryColor: "inherit",
            secondaryColor: "inherit",
            label: ""
          })), /*#__PURE__*/React.createElement(LabelText, _extends({}, labelTextOverrides, {
            tokens: tokens
          }), label, isRequired && /*#__PURE__*/React.createElement(RequiredIndicator, {
            tokens: tokens,
            "aria-hidden": "true"
          }, "*")));
        });
      }));
    }
  }]);

  return Checkbox;
}(Component);

_defineProperty(Checkbox, "defaultProps", {
  isDisabled: false,
  isInvalid: false,
  defaultChecked: false,
  isIndeterminate: false,
  theme: function theme(current, props) {
    return current(props);
  }
});

export { Checkbox as CheckboxWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
export default withAnalyticsContext({
  componentName: 'checkbox',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onChange: createAndFireEventOnAtlaskit({
    action: 'changed',
    actionSubject: 'checkbox',
    attributes: {
      componentName: 'checkbox',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(Checkbox));